import { useMemo } from "react";

import { useAppliedConfigContext } from "contexts/applied-config";
import { mergeColumnDefs } from "helpers/tables";
import type { AppliedColumnCategoryCode } from "types/tables";
import type { ColumnDef } from "@tanstack/react-table";

export const useAppliedColumns = <T>(
  categoryCode: AppliedColumnCategoryCode,
  columnDefs: Array<ColumnDef<T>>,
) => {
  const { publishedAttributesResponse } = useAppliedConfigContext();

  const appliedColumns = useMemo(
    () =>
      mergeColumnDefs<T>(categoryCode, columnDefs, publishedAttributesResponse),
    [publishedAttributesResponse, categoryCode, columnDefs],
  );

  return appliedColumns;
};
